const RoleEnum = Object.freeze({
  ALL_ADMINS: "AllAdmins",
  ALL_SCHOOL: "AllSchool",
  ONLY_MAIN_ADMIN: "OnlyMainAdmin",
  ONLY_SCHOOL_ADMIN: "OnlySchoolAdmin",
  WHO_WORKED_ON: "WhoWorkedOn",
  EXCLUDE_VAR: "ExcludeVar",
  EXCEPTION_LEAD_TECH: "ExceptionLeadTech",
  ONLY_VAR: "OnlyVar",
  EXCLUDE_TECH: "ExcludeTech",
  ONLY_TECH: "OnlyTech",
  ONLY_REPAIR_TECH: "OnlyRepairTech",
  EXCLUDE_REPAIR_VAR: "RepairAndVar",
  TECH_POINT_BOX: "TechPointBox",
  EXCLUDE_REPAIR_TECH: "ExcludeRepairTech",
  EXCLUDE_SCH_REPAIR_TECH: "ExcludeSchRepairTech",
  COMN_EXCLUDE_VAR: "ComnExcludeVar",
  COMN_REPAIR_TECH: "ComnRepairTech",
  BOTH_ADMIN: "BothAdmin",
  CREATE_TICKET_TOP_MENU: "CreateTicketTopMenu",
  EXCLUDE_TECH_VAR: "ExcludeTechVar",
  ONLY_SCH_REPAIR_TECH: "OnlySchoolRepairTech"
});

// Backend role keys (strings returned from API)
const RoleKey = Object.freeze({
  SCHOOL_ADMIN: "school_admin",
  SCHOOL_REPAIR_TECH: "school_repair_tech",
  K12_ADMIN: "k12_admin",
  K12_REPAIR_TECH: "k12_repair_tech",
  K12_ADMIN_TO_SCHOOL: "k12_admin_to_school",
  SCHOOL_TEACHER: "school_teacher",
  SCHOOL_MAINTENANCE_STAFF: "school_maintenance_staff",
  SCHOOL_REPORTS_ONLY: "school_reports_only",
  SCHOOL_BILLING: "school_billing",
  SCHOOL_DEVICE_COMPLETE_CLUB: "school_device_complete_club",
  SCHOOL_ELEVATED_REPAIR_TECH: "school_elevated_repair_tech",
  DELETED_TECH: "deleted_tech",
  K12_RELATIONSHIP_MANAGER: "k12_relationship_manager",
  K12_LOCATION_MANAGER: "k12_location_manager",
  K12_LEAD_TECH: "k12_lead_tech",
  K12_VENDOR: "k12_vendor",
  K12_DRIVER: "k12_driver",
});

const RoleGroupsByRole = {
  // [RoleEnum.ALL_ADMINS]: [5, 6, 15, 16, 17, 18, 19]
  [RoleEnum.ALL_ADMINS]: [
    RoleKey.K12_ADMIN, // 5 Rocket Admin
    RoleKey.K12_REPAIR_TECH, // 6 Repair Tech (admin)
    RoleKey.K12_RELATIONSHIP_MANAGER, // 15 Relationship Manager
    RoleKey.K12_LOCATION_MANAGER, // 16 Location Manager
    RoleKey.K12_LEAD_TECH, // 17 Lead Tech
    RoleKey.K12_VENDOR, // 18 Vendor
    RoleKey.K12_DRIVER, // 19 Driver
  ],
  // [RoleEnum.ALL_SCHOOL]: [1, 2, 8, 9, 10, 11, 12, 13, 14]
  [RoleEnum.ALL_SCHOOL]: [
    RoleKey.SCHOOL_ADMIN, // 1 Admin (school)
    RoleKey.SCHOOL_REPAIR_TECH, // 2 Repair Tech (school)
    RoleKey.SCHOOL_TEACHER, // 8 Teacher
    RoleKey.SCHOOL_MAINTENANCE_STAFF, // 9 Maintenance Staff
    RoleKey.SCHOOL_REPORTS_ONLY, // 10 Reports Only
    RoleKey.SCHOOL_BILLING, // 11 Billing
    RoleKey.DELETED_TECH, // 12 Deleted Tech
    RoleKey.SCHOOL_DEVICE_COMPLETE_CLUB, // 13 Device Complete Club
    RoleKey.SCHOOL_ELEVATED_REPAIR_TECH, // 14 Elevated Repair Tech
  ],
  // [RoleEnum.ONLY_MAIN_ADMIN]: [5]
  [RoleEnum.ONLY_MAIN_ADMIN]: [RoleKey.K12_ADMIN],
  // [RoleEnum.ONLY_SCHOOL_ADMIN]: [1]
  [RoleEnum.ONLY_SCHOOL_ADMIN]: [RoleKey.SCHOOL_ADMIN],
  // [RoleEnum.WHO_WORKED_ON]: [5, 6, 16, 17]
  [RoleEnum.WHO_WORKED_ON]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_REPAIR_TECH,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
  ],
  // [RoleEnum.EXCLUDE_VAR]: [5, 6, 15, 16, 17, 19]  (all admins except Vendor)
  [RoleEnum.EXCLUDE_VAR]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_REPAIR_TECH,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.EXCEPTION_LEAD_TECH]: [17]
  [RoleEnum.EXCEPTION_LEAD_TECH]: [RoleKey.K12_LEAD_TECH],
  // [RoleEnum.ONLY_VAR]: [18]
  [RoleEnum.ONLY_VAR]: [RoleKey.K12_VENDOR],
  // [RoleEnum.EXCLUDE_TECH]: [5, 15, 16, 19]  (exclude repair/lead tech)
  [RoleEnum.EXCLUDE_TECH]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.ONLY_TECH]: [6, 17]
  [RoleEnum.ONLY_TECH]: [RoleKey.K12_REPAIR_TECH, RoleKey.K12_LEAD_TECH],
  // [RoleEnum.ONLY_REPAIR_TECH]: [6]
  [RoleEnum.ONLY_REPAIR_TECH]: [RoleKey.K12_REPAIR_TECH],
  // [RoleEnum.EXCLUDE_REPAIR_VAR]: [5, 15, 16, 17, 19] (exclude Vendor + Repair Tech)
  [RoleEnum.EXCLUDE_REPAIR_VAR]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.TECH_POINT_BOX]: [6, 16, 17]
  [RoleEnum.TECH_POINT_BOX]: [
    RoleKey.K12_REPAIR_TECH,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
  ],
  // [RoleEnum.EXCLUDE_REPAIR_TECH]: [5, 15, 16, 17, 18, 19] (exclude Repair Tech 6)
  [RoleEnum.EXCLUDE_REPAIR_TECH]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_VENDOR,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.EXCLUDE_SCH_REPAIR_TECH]: [1, 8, 9, 10, 11, 12, 13, 14] (exclude school_repair_tech 2)
  [RoleEnum.EXCLUDE_SCH_REPAIR_TECH]: [
    RoleKey.SCHOOL_ADMIN,
    RoleKey.SCHOOL_TEACHER,
    RoleKey.SCHOOL_MAINTENANCE_STAFF,
    RoleKey.SCHOOL_REPORTS_ONLY,
    RoleKey.SCHOOL_BILLING,
    RoleKey.DELETED_TECH,
    RoleKey.SCHOOL_DEVICE_COMPLETE_CLUB,
    RoleKey.SCHOOL_ELEVATED_REPAIR_TECH,
  ],
  // [RoleEnum.COMN_EXCLUDE_VAR]:
  // [1, 2, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 19] (all except Vendor 18)
  [RoleEnum.COMN_EXCLUDE_VAR]: [
    RoleKey.SCHOOL_ADMIN,
    RoleKey.SCHOOL_REPAIR_TECH,
    RoleKey.K12_ADMIN,
    RoleKey.K12_REPAIR_TECH,
    RoleKey.SCHOOL_TEACHER,
    RoleKey.SCHOOL_MAINTENANCE_STAFF,
    RoleKey.SCHOOL_REPORTS_ONLY,
    RoleKey.SCHOOL_BILLING,
    RoleKey.DELETED_TECH,
    RoleKey.SCHOOL_DEVICE_COMPLETE_CLUB,
    RoleKey.SCHOOL_ELEVATED_REPAIR_TECH,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.COMN_REPAIR_TECH]:
  // [1, 5, 6, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19] (all except school_repair_tech 2 and school_billing 11)
  [RoleEnum.COMN_REPAIR_TECH]: [
    RoleKey.SCHOOL_ADMIN,
    RoleKey.K12_ADMIN,
    RoleKey.K12_REPAIR_TECH,
    RoleKey.SCHOOL_TEACHER,
    RoleKey.SCHOOL_MAINTENANCE_STAFF,
    RoleKey.SCHOOL_REPORTS_ONLY,
    RoleKey.DELETED_TECH,
    RoleKey.SCHOOL_DEVICE_COMPLETE_CLUB,
    RoleKey.SCHOOL_ELEVATED_REPAIR_TECH,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_VENDOR,
    RoleKey.K12_DRIVER,
  ],
  // [RoleEnum.BOTH_ADMIN]: [1, 5]
  [RoleEnum.BOTH_ADMIN]: [RoleKey.SCHOOL_ADMIN, RoleKey.K12_ADMIN],

  // Top Menu Create Ticket Access Admin & School Side
  [RoleEnum.CREATE_TICKET_TOP_MENU]: [
    RoleKey.K12_ADMIN,
    RoleKey.K12_REPAIR_TECH,
    RoleKey.K12_RELATIONSHIP_MANAGER,
    RoleKey.K12_LOCATION_MANAGER,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_DRIVER,
    RoleKey.SCHOOL_ADMIN,
    RoleKey.SCHOOL_REPAIR_TECH,
    RoleKey.DELETED_TECH,
    RoleKey.SCHOOL_ELEVATED_REPAIR_TECH,
  ],

  // [Only School Repair Tech] : [2]
  [RoleEnum.ONLY_SCH_REPAIR_TECH]: [
    RoleKey.SCHOOL_REPAIR_TECH
  ],

  [RoleEnum.EXCLUDE_TECH_VAR]: [
    RoleKey.K12_REPAIR_TECH,
    RoleKey.K12_LEAD_TECH,
    RoleKey.K12_VENDOR
  ]
};

const hasRoleAccess = (roleKey, group) => {
  if (!roleKey) return false;

  const roles = RoleGroupsByRole[group];

  if (!Array.isArray(roles)) return false;

  return roles.some((r) => r === roleKey); // exact match only
};
export { hasRoleAccess, RoleEnum, RoleKey };
